/* eslint-disable react/jsx-props-no-spreading */
import {noop} from 'lodash';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Dropdown} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownBanner} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownBanner';
import {DropdownList} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownList';
import {DropdownItem} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItem';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {PopoverTransferProps} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {flexCenter} from '../../../../../libs/shared/ui/src/styles/mixins';
import {AnalyticsScalarMetricsEnum} from '../../../../models/api/analyticsMetricsModel';
import {getMetricLabels, maybeRenderFeaturePillAndTooltip} from '../../../helpers/metricLabels';

/*
 * Props.
 */

interface CardMetricPickerProps extends PopoverTransferProps {
  metrics: ReadonlyArray<AnalyticsScalarMetricsEnum>;
  displayedMetrics: ReadonlyArray<AnalyticsScalarMetricsEnum>;
  onMetricClick: (arg: AnalyticsScalarMetricsEnum) => void;
  maxCards: number;
}

/*
 * Styles.
 */

const StyledDropdownItemContent = styled(DropdownItemContent)`
  ${flexCenter};
  gap: 5px;
`;

/*
 * Component.
 */

export const CardMetricPicker: FC<CardMetricPickerProps> = ({
  metrics,
  displayedMetrics,
  onMetricClick,
  maxCards,
  ...popoverTransferProps
}) => {
  const metricsWithLabels = metrics.map(getMetricLabels);

  return (
    <Dropdown {...popoverTransferProps}>
      {/* onRequestClose prop is used to keep the menu open when an item is clicked */}
      <DropdownList {...popoverTransferProps} onRequestClose={noop}>
        <DropdownBanner>
          <Trans id="analytics-hero-picker-header">Unselect a metric to replace it</Trans>
        </DropdownBanner>
        {metricsWithLabels.map(({id, label, isBeta, isNew, tooltip}) => {
          const isChecked = id && displayedMetrics.includes(id);

          return (
            <DropdownItem
              key={id}
              isChecked={isChecked}
              isDisabled={!isChecked && displayedMetrics.length >= maxCards}
              onSelect={() => id && onMetricClick(id)}
              checkmarkLabel={label}
            >
              <StyledDropdownItemContent isChecked={isChecked}>
                {label}
                {maybeRenderFeaturePillAndTooltip(isBeta, isNew, tooltip)}
              </StyledDropdownItemContent>
            </DropdownItem>
          );
        })}
      </DropdownList>
    </Dropdown>
  );
};
